import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input, } from "@angular/core";
import { AppState } from "../../../app.service";
import { formatEuro, getPromoSubprices } from "@api/utils";
var TotalCostsComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function TotalCostsComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        this.monthlyCosts = 0;
        this.monthlyCostsAfterFirstYear = 0;
        this.onetimeCosts = 0;
        this.formatEuro = formatEuro;
        this.promoSubpriceLabels = "";
        this.promoSubprices = "";
        this.insurancesAmount = 0;
        this.insurancesCost = 0;
    }
    TotalCostsComponent.prototype.ngOnInit = function () {
        this.calculateCosts(this.basketItems);
        var checkoutContainer = document.getElementsByTagName("vfeo-checkout");
        this.vat = checkoutContainer[0].getAttribute("data-vat");
    };
    TotalCostsComponent.prototype.ngOnChanges = function (changes) {
        var basketItems = changes.basketItems;
        this.calculateCosts(basketItems.currentValue);
    };
    TotalCostsComponent.prototype.calculateCosts = function (basketItems) {
        var monthlyCosts = 0;
        var monthlyCostsAfterFirstYear = 0;
        var onetimeCosts = 0;
        var insurancesAmount = 0;
        var insurancesCost = 0;
        var promos = {};
        for (var basketItem in basketItems) {
            if (basketItems[basketItem].offer.insuranceOption.length) {
                insurancesAmount += basketItems[basketItem].amount;
                insurancesCost +=
                    basketItems[basketItem].amount *
                        basketItems[basketItem].offer.getInsurancePrice();
            }
            monthlyCosts +=
                basketItems[basketItem].offer.getMonthlyPrice() *
                    basketItems[basketItem].amount;
            monthlyCostsAfterFirstYear +=
                basketItems[basketItem].offer.getMonthlyPriceAfterFirstYear() *
                    basketItems[basketItem].amount;
            onetimeCosts +=
                basketItems[basketItem].offer.getOnetimePrice() *
                    basketItems[basketItem].amount;
            onetimeCosts +=
                basketItems[basketItem].offer.getActivationFee() *
                    basketItems[basketItem].amount;
            var subprices = getPromoSubprices(basketItems[basketItem].offer);
            for (var _i = 0, subprices_1 = subprices; _i < subprices_1.length; _i++) {
                var subprice = subprices_1[_i];
                if (!promos[subprice.runtime]) {
                    promos[subprice.runtime] = 0;
                }
            }
        }
        var cummulatedPrices = 0;
        for (var promo in promos) {
            for (var basketItem in basketItems) {
                promos[promo] +=
                    basketItems[basketItem].offer.getMonthlyPriceAfterNMonths(promo) * basketItems[basketItem].amount;
            }
        }
        this.promoSubpriceLabels = "";
        this.promoSubprices = "";
        var cummulatedPromoSubPrice = 0;
        for (var promo in promos) {
            cummulatedPromoSubPrice = promos[promo];
            if (parseInt(promo) < 24 && parseInt(promo) > 2) {
                this.promoSubpriceLabels = this.promoSubpriceLabels + " Ab dem " + promo + ". Monat <br>";
                this.promoSubprices = this.promoSubprices + " " + formatEuro(cummulatedPromoSubPrice) + " <br>";
            }
        }
        this.monthlyCosts = monthlyCosts;
        this.monthlyCostsAfterFirstYear = monthlyCostsAfterFirstYear;
        this.onetimeCosts = onetimeCosts;
        this.insurancesAmount = insurancesAmount;
        this.insurancesCost = insurancesCost;
    };
    TotalCostsComponent.prototype.submitState = function (value) { };
    return TotalCostsComponent;
}());
export { TotalCostsComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/basket-overview/total-costs/total-costs.component.ts
// module id = null
// module chunks = 